module.exports = __webpack_public_path__ + "static/media/pink_animal_amphibians_6.d2fb2b5e.webp";